import { css } from "lit";
export const buttonStyles = css `
    .button {
        font-family: inherit;
        margin: 40px 0;
        padding: 10px 20px 6px;
        font-size: 1.5em;
        border: none;
        border-radius: 5px;
        /* solid shadow to make the button look 3-dimensional */
        box-shadow: 0 6px 0 #743f39;
        background-color: #ead4aa;
    }

    .button:hover {
        background-color: #f0e3c9;
    }

    /* when button is pressed, remove the shadow and move the button down */
    .button:active {
        box-shadow: none;
        transform: translateY(6px);
    }
`;
